export default __webpack_public_path__ + "static/media/Skup Pula (7).51bea76f.JPG";